import React from 'react';
import {useOrdersState} from '../../state';
import View from "./OrderDetails/View";

interface OrderDetailsProps {
    onBack: () => void;
    order: any;
}

const OrderDetails: React.FC<OrderDetailsProps> = ({onBack}) => {
    const {handleCancelOrder, selectedOrder, isLoading} = useOrdersState();

    const shouldDisplayCancelButton =
        selectedOrder &&
        (selectedOrder.SALDOC.STATUSNAMELIVRARE === 'Pending' ||
            selectedOrder.SALDOC.STATUSNAMELIVRARE === 'Pending Payment' ||
            selectedOrder.SALDOC.STATUSNAMELIVRARE === 'Hold');

    const handleCancelAndRedirect = async () => {
        await handleCancelOrder();
        await new Promise(resolve => setTimeout(resolve, 5000));
        window.location.href = `${window.location.origin}/softone_sales_orders/order/orderhistory`;
    };

    return (
        <div className="order-view-buttons">
            <View/>
            <button className="action-secondary"
                    style={{margin: '10px'}}
                    onClick={onBack}>
                Lista de comenzi
            </button>
            {shouldDisplayCancelButton && (
                <button className="action-secondary"
                        style={{margin: '10px'}}
                        onClick={handleCancelAndRedirect}
                        disabled={isLoading}>
                    {isLoading ? 'Se anuleaza...' : 'Anuleaza comanda'}
                </button>
            )}
        </div>
    );
};

export default OrderDetails;
